// :cow: Cosmose CONFIDENTIAL :iso:
import { Component, OnDestroy, OnInit } from '@angular/core';
import { LanguageService } from '@med/app/core/language/service/language.service';
import { filter, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Store } from '@ngrx/store';
import { Language } from '@med/app/core/language/service/language.enum';
import { ConfigService } from '@med/app/core/config/config.service';
import { SpinnerService } from '@med/app/core/services/spinner.service';

interface LanguageItem {
  code: string;
  value: string;
}

@Component({
  selector: 'e-language-selection',
  templateUrl: './language-selection.component.html',
  styleUrls: ['./language-selection.component.scss'],
})
export class LanguageSelectionComponent implements OnInit, OnDestroy {

  isDropdownActive = false;
  languages: LanguageItem[];
  selectedLanguage: string;
  showComponent: boolean;

  private unsubscribe$ = new Subject<void>();

  constructor(
    private languageService: LanguageService,
    private store: Store,
    private configService: ConfigService,
    private spinnerService: SpinnerService,
  ) {

  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  ngOnInit() {
    const languageMap: LanguageItem[] = [
      {code: Language.english, value: 'English'},
      {code: Language.chinese, value: '中文'},
      {code: Language.japanese, value: '日本語'},
    ];
    this.languages = this.configService.getConfig().languages.map(key => languageMap.find(l => l.code === key));
    this.showComponent = this.languages.length > 1;

    this.languageService.getLanguage()
      .pipe(
        filter(value => !!value),
        takeUntil(this.unsubscribe$),
      ).subscribe(language => this.selectedLanguage = language);
  }

  public onCodeClick(code: string): void {
    if (code === this.selectedLanguage) {
      return;
    }
    this.spinnerService.show();
    this.languageService.saveLanguage(code);
    document.location.reload();
  }

  onToggleDropdown() {
    this.isDropdownActive = true;
  }
}
